import { Controller } from '@hotwired/stimulus';

// 給与一覧の「補足情報」ボトムドック (#1871)
// メモ・AI専門家コメント・登録/更新情報を1つのドロワーにまとめ、
// 画面下部のボタンで下からせり上げて開閉する。
export default class extends Controller {
  static targets = ['drawer', 'scrim', 'button', 'label'];
  static classes = ['open'];
  static values = {
    openLabel: { type: String, default: '補足情報を開く' },
    closeLabel: { type: String, default: '補足情報を閉じる' },
  };

  connect() {
    this.open = false;
    this.boundKeydown = this.handleKeydown.bind(this);
    document.addEventListener('keydown', this.boundKeydown);
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundKeydown);
  }

  toggle() {
    this.setOpen(!this.open);
  }

  close() {
    this.setOpen(false);
  }

  setOpen(value) {
    this.open = value;
    const openClass = this.hasOpenClass ? this.openClass : 'open';
    this.drawerTarget.classList.toggle(openClass, value);
    if (this.hasScrimTarget) this.scrimTarget.classList.toggle('show', value);
    if (this.hasButtonTarget) this.buttonTarget.classList.toggle('open', value);
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = value ? this.closeLabelValue : this.openLabelValue;
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.open) this.setOpen(false);
  }
}
